<template lang="pug">
.container-fluid
	.row
		.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-3
			.alert.alert-info
				p
					b Gestión de equipos
				p Desde aquí puedes gestionar los equipos y sus líderes. Un líder de equipo es el encargado de validar los registros horarios de sus miembros
				p Los usuarios que no pertenezcan a ningún equipo (como miembros) serán validados automáticamente
		.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-5
			.card
				.card-header.bg-info.text-white
					span.fa.fa-group.mr-2
					| Equipos
					button.float-right.btn.btn-sm.btn-warning(@click="nuevo")
						span.fa.fa-plus.mr-2
						| Nuevo equipo
				table.table.table-striped.m-0
					thead
						tr
							th ID
							th Nombre
							th Líderes
							th Miembros
							th
					tbody
						tr(
							v-for="equipo in listadoEquipos"
							:key="equipo.ID_equipo"
						)
							td(style="vertical-align:middle;") {{equipo.ID_equipo}}
							td(style="vertical-align:middle;") {{equipo.nombre}}
							td(style="vertical-align:middle;") {{muestraLideres(equipo.lideres)}}
							td(style="vertical-align:middle;") {{equipo.miembros.length}}
							td.text-right
								button.btn.btn-sm.btn-danger.m-2(@click="delEquipo(equipo.ID_equipo)")
									span.fa.fa-trash
								button.btn.btn-sm.btn-primary.m-2(@click="getEquipo(equipo.ID_equipo)")
									span.fa.fa-edit
								
		.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4(v-if="editando")
			.card
				.card-header.bg-dark.text-white
					span.fa.fa-group.mr-2
					| {{equipo.nombre}}
				.card-body
					.form-group
						label
							b Nombre del equipo
						input.form-control(v-model="equipo.nombre", placeholder="Escribe un nombre")
					.form-group
						label
							b Líderes del equipo
						input-query.form-control(
							inputClass="form-control"
							placeholder="Busca y añade miembros"
							url="gestion-horaria/php/api/query-usuarios.php"
							:realtime="true"
							@selected="nuevoLider($event)"
						)
					table.table.m-0
						tr(
							v-for="lider in equipo.lideres"
							:key="lider.LiderID"
						)
							td {{lider.LiderNombre}}
							td.text-right
								button.btn.btn-sm.btn-danger(@click="quitaLider(lider.LiderID)")
									span.fa.fa-trash
				.card-body.bg-light
					.form-group
						label
							b Miembros del equipo
						input-query.form-control(
							inputClass="form-control"
							placeholder="Busca y añade miembros"
							url="gestion-horaria/php/api/query-usuarios.php"
							:realtime="true"
							@selected="nuevoMiembro($event)"
						)
					table.table.m-0
						tr(
							v-for="miembro in equipo.miembros"
							:key="miembro.UsuarioID"
						)
							td {{miembro.UsuarioNombre}}
							td.text-right
								button.btn.btn-sm.btn-danger(@click="quitaMiembro(miembro.UsuarioID)")
									span.fa.fa-trash
				.card-footer
					button.btn.btn-sm.btn-primary.m-2(@click="guardar")
						span.fa.fa-save.mr-2
						| Guardar
					button.btn.btn-sm.btn-danger.m-2(@click="editando = false")
						span.fa.fa-times.mr-2
						| Cancelar
</template>

<script>
import axios from 'axios'
export default {
	data () {
		return {
			listadoEquipos: [],
			equipo: {
				ID_equipo: null,
				nombre: null,
				miembros: [],
				lideres: []
			},
			editando: false
		}
	},
	created () {
		this.getListado()
	},
	methods: {
		nuevo () {
			this.equipo.ID_equipo = null
			this.equipo.nombre = null
			this.equipo.miembros = []
			this.equipo.lideres = []
			this.editando = true
		},
		getListado () {
			axios.get('gestion-horaria/php/api/getEquipos.php')
				.then(res => {
					this.listadoEquipos = res.data
				})
				.catch(this.$responseError)
		},
		getEquipo (EquipoID) {
			axios.get('gestion-horaria/php/api/getEquipo.php?EquipoID=' + EquipoID)
				.then(res => {
					this.equipo = res.data
					this.editando = true
				})
				.catch(this.$responseError)
		},
		nuevoMiembro (ev) {
			this.equipo.miembros.push({
				UsuarioID: ev.data.ID,
				UsuarioNombre: ev.data.nombre + ' ' + ev.data.apellidos
			})
		},
		quitaMiembro (ID) {
			this.equipo.miembros = this.equipo.miembros.filter(m => m.UsuarioID !== ID)
		},
		nuevoLider (ev) {
			this.equipo.lideres.push({
				LiderID: ev.data.ID,
				LiderNombre: ev.data.nombre + ' ' + ev.data.apellidos
			})
		},
		quitaLider (ID) {
			this.equipo.lideres = this.equipo.lideres.filter(m => m.LiderID !== ID)
		},
		muestraLideres (lideres) {
			return lideres.reduce((ant, l) => {
				ant.push(l.LiderNombre)
				return ant
			}, []).join(', ')
		},
		guardar () {
			axios.post('gestion-horaria/php/api/setEquipo.php', this.equipo)
				.then(res => {
					this.getListado()
					this.getEquipo(res.data.ID_equipo)
					this.$store.commit('toast/success', {
						titulo: 'Equipo guardado'
					})
				})
				.catch(this.$responseError)
		},
		delEquipo (ID) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar equipo',
				mensaje: `¿Quieres eliminar este equipo?`,
				callback: acepta => {
					if (acepta) {
						axios.post('gestion-horaria/php/api/delEquipo.php', {ID_equipo: ID})
							.then(res => {
								this.getListado()
								this.editando = false
								this.$store.commit('toast/success', {
									titulo: 'Equipo eliminado'
								})
							})
							.catch(this.$responseError)
					}
				}
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/modulos/gestion-horaria/vue/equipos/equipos.vue